import {Determinant} from "./determinant";
import { SelectSubjectType } from "./select-subject";

export class GridDeterminant extends Determinant {

  public subject: SelectSubjectType;
  public rowDeterminant: Determinant;

}
